export default {
  disabled: false
};


//////////////////
// WEBPACK FOOTER
// ../~/react-toastify/~/react-transition-group/esm/config.js
// module id = 459
// module chunks = 0